import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import { MLogoContainerSize } from '../MLogoContainer/MLogoContainer.types';

export enum MBrandElementType {
  Logo = 'Logo',
  Icon = 'Icon',
  Image = 'Image',
}

export interface DACImage {
  damPath?: string;
  assetPath?: string;
  altText?: string;
  dynamic?: boolean;
  enableSmartCrop?: boolean;
}

export interface MBrandElementProps {
  type: MBrandElementType;
  brand?: string;
  logoColor?: 'background-aware' | 'color';
  logoSize?: MLogoContainerSize;
  iconSize?: AIconSize;
  icon?: string;
  image?: DACImage;
}
